import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveInstance = (state, instance) => state.some((item) => item.referralId === instance.referralId);

export const referralsSlice = createSlice({
  name: 'referrals',
  initialState: initialState,
  reducers: {
    clearReferrals: () => {
      return initialState;
    },

    addReferral: (state, action) => {
      const instance = action.payload;
      return haveInstance(state, instance) ? state : [...state, instance];
    },

    updateReferral: (state, action) => {
      const instance = action.payload;
      const others = state.filter((ref) => ref.referralId !== instance.referralId);
      return [...others, instance];
    },

    deleteReferralWithId: (state, action) => {
      const referralId = action.payload;
      return state.filter((ref) => ref.referralId !== referralId);
    },
  },
});

export const { clearReferrals, addReferral, updateReferral, deleteReferralWithId } = referralsSlice.actions;

export default referralsSlice.reducer;
